"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateChoice = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var semantic_ui_react_1 = require("semantic-ui-react");
var searchParamsSlice_1 = require("../../../features/searchParams/searchParamsSlice");
var useTranslationNs_1 = require("../../../hooks/useTranslationNs");
var FilterDropdown_1 = __importDefault(require("../FilterDropdown"));
var FilterSummary_1 = __importDefault(require("../FilterSummary"));
var SelectedValues_1 = __importDefault(require("../SelectedValues"));
exports.StateChoice = react_1.memo(function (_a) {
    var onSelect = _a.onSelect, filter = _a.filter, toggleDropdown = _a.toggleDropdown, appliedFilters = _a.appliedFilters;
    var i18n = react_i18next_1.useTranslation('common').i18n;
    var lang = i18n.language;
    var allFilter = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var states = (allFilter === null || allFilter === void 0 ? void 0 : allFilter.state) ? allFilter === null || allFilter === void 0 ? void 0 : allFilter.state.options : [];
    var label = filter.label;
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    var _b = react_1.useState([]), selected = _b[0], setSelected = _b[1];
    react_1.useEffect(function () {
        var _a;
        setSelected(((_a = appliedFilters.state) === null || _a === void 0 ? void 0 : _a.length) ? appliedFilters.state : []);
    }, [appliedFilters]);
    var toggleSelect = function (value) {
        onSelect(value);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterSummary_1.default, { handleClick: toggleDropdown, label: label.toLocaleUpperCase() },
            selected && (react_1.default.createElement(SelectedValues_1.default, { selected: selected, states: states })),
            !selected.length && (react_1.default.createElement("span", { className: "default-val" }, getTranslation('CHOOSE')))),
        react_1.default.createElement(FilterDropdown_1.default, { handleClick: toggleDropdown, label: label.toUpperCase(), filterName: filter.name },
            react_1.default.createElement("ul", { role: "listbox", className: "choices" }, states.map(function (state, index) {
                var _a;
                var label = (_a = state.translations[lang]) !== null && _a !== void 0 ? _a : state.text;
                var isChecked = selected.includes(String(state.govId));
                return (react_1.default.createElement("li", { key: index },
                    react_1.default.createElement(semantic_ui_react_1.Checkbox, { checked: isChecked, onChange: function () {
                            toggleSelect(state.govId);
                        }, label: label })));
            })))));
});
